import React from "react";

import { useTranslation } from "react-i18next";

import { Modal, Spin, Tabs, Typography } from "antd";

import { useDispatch, useSelector } from "react-redux";

import slice from "./reducer";
import saga from "./saga";

import { makeSelectLoading, makeSelectOpen } from "./selectors";
import { makeSelectLanguage, makeSelectTransportCharacteristics } from "../../containers/App/selectors";

import { ApplicationUtils } from "../../viewModels/Applications/ApplicationModel";

import { TransportCharacteristicsLoadType } from "../../dto/Settings/TransportCharacteristicDto";

import FtlForm from "./components/FtlForm";
import FclForm from "./components/FclForm";
import AirForm from "./components/AirFrom";
import LtlForm from "./components/LtlForm";
import LclForm from "./components/LclForm";
import FwlForm from "./components/FwlForm";
import LwlForm from "./components/LwlForm";
import BulkForm from "./components/BulkForm";
import RoroForm from "./components/RoroForm";
import OversizedCargoForm from "./components/OversizedCargoForm";
import exhaustiveCheck from "../../utils/exhaustiveCheck";
import useInjectSaga from "../../utils/useInjectSaga";

const CreateApplicationModal = React.memo(() => {
  const { t } = useTranslation("translations");

  useInjectSaga("createApplicationModal", saga);

  const dispatch = useDispatch();

  const lang = useSelector(makeSelectLanguage());
  const transportCharacteristics = useSelector(makeSelectTransportCharacteristics());

  const open = useSelector(makeSelectOpen);
  const loading = useSelector(makeSelectLoading);

  const getForm = (loadType: TransportCharacteristicsLoadType) => {
    switch (loadType) {
      case "FTL":
        return <FtlForm />;
      case "AIR":
        return <AirForm />;
      case "LTL":
        return <LtlForm />;
      case "LCL":
        return <LclForm />;
      case "FWL":
        return <FwlForm />;
      case "LWL":
        return <LwlForm />;
      case "BULK":
        return <BulkForm />;
      case "RO_RO":
        return <RoroForm />;
      case "OVERSIZED_CARGO":
        return <OversizedCargoForm />;
      case "FCL":
        return <FclForm />;
      default:
        return exhaustiveCheck(loadType);
    }
  };

  const handleClose = React.useCallback(() => {
    dispatch(slice.actions.closeModal());
  }, [dispatch]);

  return (
    <Modal open={open} onCancel={handleClose} footer={null} destroyOnHidden width={1000} title={t("new_calculation")}>
      <Spin spinning={loading}>
        <Tabs
          destroyOnHidden
          items={transportCharacteristics.map((x) => ({
            key: x.loadType,
            label: ApplicationUtils.getTransportCharacteristicsTypeLabelByType(x.loadType, lang),
            children: (
              <>
                <Typography.Title level={4}>
                  {t("calculate_transportation")} {ApplicationUtils.getTransportCharacteristicsTypeLabelByType(x.loadType, lang)}
                </Typography.Title>
                {getForm(x.loadType)}
              </>
            ),
          }))}
        />
      </Spin>
    </Modal>
  );
});

export default CreateApplicationModal;
